export const environment = {
   production: true,
   ibtVendorServiceUrl: "https://testibtsrv.certiport.com/",
   appInsightsConnString: "InstrumentationKey=7fc9c548-0d72-45c3-95c6-6b55f716a7fa;IngestionEndpoint=https://centralus-0.in.applicationinsights.azure.com/",
   appInsightsInstrumentationKey: "7fc9c548-0d72-45c3-95c6-6b55f716a7fa"
};
